import { Box } from '@mui/material';
import { falsyCheckDate } from 'utils';
import { DataCellProps } from '../types';

export const DataDeletionDeletionDateCell = ({ team }: DataCellProps) => {
  return <Box>{falsyCheckDate(team.dataDeletionScheduledDate)}</Box>;
};
